module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sidebar', {
    attrs: {
      "enableSwipeOut": _vm.enableSwipeOut
    },
    model: {
      value: (_vm.sidebarStatus),
      callback: function($$v) {
        _vm.sidebarStatus = $$v
      },
      expression: "sidebarStatus"
    }
  }, [_c('div', {
    staticClass: "app-sidebar-content"
  }, [_c('div', {
    staticClass: "app-sidebar-header"
  }, [_c('div', {
    staticClass: "user-avatar"
  }, [_c('v-icon', {
    staticClass: "user-avatar-icon",
    attrs: {
      "light": ""
    }
  }, [_vm._v("face")])], 1), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_c('v-icon', [_vm._v("person")]), _vm._v(_vm._s(_vm.user.name))], 1), _vm._v(" "), _c('div', {
    staticClass: "user-location"
  }, [_c('v-icon', [_vm._v("room")]), _vm._v(_vm._s(_vm.user.location))], 1), _vm._v(" "), _c('div', {
    staticClass: "user-email"
  }, [_c('v-icon', [_vm._v("email")]), _vm._v(_vm._s(_vm.user.email))], 1)]) : _c('p', {
    staticClass: "user-login",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])]), _vm._v(" "), (_vm.blocks) ? _c('div', {
    staticClass: "app-sidebar-blocks"
  }, [_c('ul', _vm._l((_vm.blocks), function(block, index) {
    return _c('li', {
      key: index,
      staticClass: "app-sidebar-block"
    }, [(block.sublistTitle) ? _c('div', {
      staticClass: "sub-list-title"
    }, [_vm._v(_vm._s(block.sublistTitle))]) : _vm._e(), _vm._v(" "), (block.list) ? _c('ul', _vm._l((block.list), function(item) {
      return _c('li', {
        directives: [{
          name: "ripple",
          rawName: "v-ripple",
          value: ({
            class: 'grey--text'
          }),
          expression: "{class: 'grey--text'}"
        }],
        key: item.text,
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.closeAndGo(item.route, item.action)
          }
        }
      }, [(item.icon || item.image || item.svg) ? _c('span', {
        staticClass: "app-sidebar-block-left-icon"
      }, [(item.image) ? _c('img', {
        attrs: {
          "src": item.image,
          "alt": item.alt
        }
      }) : (item.svg) ? _c('icon', {
        attrs: {
          "name": item.svg
        }
      }) : (item.icon) ? _c('v-icon', {
        staticClass: "grey--text text--lighten-1"
      }, [_vm._v(_vm._s(item.icon))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.text) ? _c('span', {
        staticClass: "app-sidebar-block-text"
      }, [_vm._v(_vm._s(item.text))]) : _vm._e()])
    })) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "toast"
    }
  }, [(_vm.toast) ? _c('p', {
    staticClass: "app-sidebar-toast"
  }, [_vm._v("Only a demo")]) : _vm._e()])], 1), _vm._v(" "), _c('login', {
    attrs: {
      "show": _vm.showLogin,
      "logout": _vm.aclogout
    },
    on: {
      "close-login": _vm.closeLogin
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215f825f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loaders/theme-loader.js??ref--2-1!./src/components/AppSidebar.vue
// module id = 494
// module chunks = 7